// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__18PXM","search":"Settings_search__2lqqc","filter":"Settings_filter__DoMSC"};